import createIcon from '../../createIcon';

/**
 * @component @name Restaurant
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgOUg5VjJIN1Y5SDVWMkgzVjlDMyAxMS4xMiA0LjY2IDEyLjg0IDYuNzUgMTIuOTdWMjJIOS4yNVYxMi45N0MxMS4zNCAxMi44NCAxMyAxMS4xMiAxMyA5VjJIMTFWOVpNMTYgNlYxNEgxOC41VjIySDIxVjJDMTguMjQgMiAxNiA0LjI0IDE2IDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Restaurant = createIcon('Restaurant', [
  [
    'path',
    {
      d: 'M11 9H9V2H7V9H5V2H3V9C3 11.12 4.66 12.84 6.75 12.97V22H9.25V12.97C11.34 12.84 13 11.12 13 9V2H11V9ZM16 6V14H18.5V22H21V2C18.24 2 16 4.24 16 6Z',
      key: '1dacol',
    },
  ],
]);

export default Restaurant;
